export default __webpack_public_path__ + "static/media/os_aran_400ffc-webfont.49176f1a.woff2";